/**
 * O andamento do pedido que cria o ambiente, no cartão de
 * `terraform_stage_create`. Antes, o cartão parava em "Executado" e a criação
 * (MR, merge, replan, um apply de centenas de recursos) corria sem nada na
 * tela entre um aviso e outro. Reusa as peças do cartão de ajuste: a linha do
 * tempo e o painel de execução, que abre sozinho durante o apply.
 */
import { Stack } from '@mantine/core'
import type { PedidoDoCartao } from '@/api/terraformRunner'
import { DecisaoNoCartao } from './DecisaoNoCartao'
import { LinhaDoTempoDoPedido } from './LinhaDoTempoDoPedido'
import { MotivoDoPedido } from './MotivoDoPedido'
import { PainelDeExecucao, totalDoPlan } from './PainelDeExecucao'
import { Dado } from './Dado'

export function AndamentoDaCriacao({ pedido }: { pedido: PedidoDoCartao }) {
  return (
    <Stack gap={6} mt="xs">
      {pedido.linha_plan && <Dado>{pedido.linha_plan}</Dado>}
      <LinhaDoTempoDoPedido linha={pedido.linha_do_tempo} />
      <DecisaoNoCartao pedido={pedido} />
      {pedido.terminal && pedido.motivo_terminal && (
        <MotivoDoPedido texto={pedido.motivo_terminal} />
      )}
      <PainelDeExecucao pedidoId={pedido.id} disponivel={pedido.andamento_disponivel}
                        abertoDeInicio={pedido.estado === 'aplicando'}
                        acoes={pedido.acoes} totalDeMudancas={totalDoPlan(pedido.linha_plan)} />

    </Stack>
  )
}
